export type FormValues = {
  scopesValues: Record<string, boolean>;
  refresh_always: boolean;
  [key: string]: unknown;
  client_id?: string;
};

export type UploadFileProps = {
  name: string;
  file: File;
  callback: (value: string) => void;
};

export enum FieldNames {
  CLIENT_SECRET = 'client_secret',
  CUSTOM_RETURN_URL = 'custom_return_url',
  REFRESH_ALWAYS = 'refresh_always',
  SCOPES_VALUES = 'scopesValues'
}

export enum DocumentationLink {
  BABKA = 'https://developers.xsolla.com/doc/login/how-to/xsolla-account-login'
}

export const filterValues: Array<string> = [FieldNames.SCOPES_VALUES, FieldNames.REFRESH_ALWAYS];
